import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RouteWrapper from './component/RouteWrapper';

ReactDOM.render(
  <React.StrictMode>
    <RouteWrapper></RouteWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);
